import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CocCollectionForm from "./cocCollectionComponents/CocCollectionForm";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useAppMeta } from "hooks";
import { useCreateCocCollectionMutation } from "store/services/cocCollectionApi";

const CocCollectionCreateScreen = () => {
  const navigate = useNavigate();
  const breadcrumbs = [
    {
      title: "Counter Collection",
      path: "/app/crm/coc-collection/list",
    },
    {
      title: "New Counter Collection",
    },
  ];

  const [createCocCollection, { isLoading: creatingCocCollection }] =
    useCreateCocCollectionMutation();

  const handleCocCollectionCreate = async (data) => {
    try {
      await createCocCollection(data).unwrap();
      navigate(breadcrumbs[0].path);
      toast.success("Coc Collection created successfully");
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create Coc Collection!"
      );
    }
  };

  useAppMeta("New COC Collection");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingCocCollection}>
      <BreadcrumbLayout.Paper>
        <CocCollectionForm
          isBusy={creatingCocCollection}
          onSubmit={handleCocCollectionCreate}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default CocCollectionCreateScreen;
